<template>
  <v-app id="inspire" class="vue-app">
    <link
      href="https://fonts.googleapis.com/css?family=Material+Icons"
      rel="stylesheet"
    />
    <v-app-bar color="navbar" app>
      <v-spacer v-if="$vuetify.breakpoint.lgAndUp" />
      <router-link :to="{ name: 'home' }">
        <v-img
          alt="Logo"
          class="shrink"
          :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }"
          :width="$vuetify.breakpoint.mdAndUp ? '50' : '30'"
          contain
          :src="require('./assets/logo.png')"
          :to="{ name: 'home' }"
        />
      </router-link>
      <v-btn
        depressed
        text
        :class="{ 'mr-8': $vuetify.breakpoint.mdAndUp }"
        href="/"
      >
        <v-toolbar-title
          :style="{ 'font-size': $vuetify.breakpoint.mdAndUp ? '' : '.9em' }"
          >VANCOUVER GLOBAL SHIPPING</v-toolbar-title
        >
      </v-btn>

      <template v-if="$vuetify.breakpoint.lgAndUp">
        <template v-for="(link, index) in links">
          <v-menu v-if="link.dropdown" :key="`link-${index}`" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-1" text v-on="on">
                {{ link.name }}
                <v-icon>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list color="navbar">
              <template v-for="(sublink, subIndex) in link.dropdown.links">
                <v-list-item
                  v-if="sublink.download && sublink.new"
                  exact
                  :key="`sublink-${subIndex}`"
                  :to="sublink.to"
                  :href="sublink.href"
                  target="_blank"
                >
                  <v-list-item-avatar>
                    <v-icon color="primary" small> open_in_new </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title
                    class="sublink text-left py-1"
                    v-html="sublink.name"
                  ></v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-else-if="sublink.download"
                  exact
                  :key="`sublink-${subIndex}`"
                  @click="showFile(sublink, sublink.embed)"
                >
                  <v-list-item-avatar> </v-list-item-avatar>
                  <v-list-item-title
                    class="sublink text-left py-1"
                    v-html="sublink.name"
                  ></v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-else
                  exact
                  :key="`sublink-${subIndex}`"
                  :to="sublink.to"
                  :href="sublink.href"
                >
                  <v-list-item-avatar> </v-list-item-avatar>
                  <v-list-item-title
                    class="sublink text-left py-1"
                    v-html="sublink.name"
                  ></v-list-item-title>
                </v-list-item>
                <div
                  v-if="subIndex < link.dropdown.links.length - 1"
                  class="mx-4 nav-divider"
                  :key="`divider-${subIndex}`"
                />
              </template>
            </v-list>
          </v-menu>
          <v-btn
            v-else
            class="mr-1"
            :key="`link-${index}`"
            :to="link.to"
            :href="link.href"
            text
            v-html="link.name"
          >
          </v-btn>
        </template>
        <v-spacer />

        <!-- <v-btn
          @click.stop="comingSoon()"
          class="ml-8 mr-4"
          text
          color="primary"
        >
          Tracking
        </v-btn>
        <v-divider inset vertical /> -->
        <v-btn
          href="https://vancouverglobalshipping.app.shipthis.co/session/signin"
          class="mx-2"
          rounded
          color="white"
        >
          <span class="font-weight-bold primary--text">Customer Login</span>
        </v-btn>
        <v-divider inset vertical />
        <v-btn href="/#services" class="mx-2" rounded color="primary">
          <span class="text-none">Quotes</span>
        </v-btn>

        <v-spacer />
      </template>
      <template v-else>
        <v-spacer />
        <v-menu
          v-model="menu"
          min-width="280px"
          max-height="400px"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" icon color="primary" v-on="on">
              <v-icon large>menu</v-icon>
            </v-btn>
          </template>
          <v-list class="py-0">
            <template v-for="(link, index) in links">
              <v-expansion-panels
                flat
                v-if="link.dropdown"
                :key="`link-${index}`"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    ripple
                    class="text-center expansion-header-nav"
                  >
                    <template v-slot:default>
                      <div class="text-center v-list-item__title">
                        {{ link.name }}
                      </div>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="expansion-nav py-0">
                    <v-list class="py-0">
                      <template
                        v-for="(sublink, subIndex) in link.dropdown.links"
                      >
                        <v-list-item
                          v-if="sublink.href && sublink.download && sublink.new"
                          exact
                          two-line
                          :key="`sublink-${subIndex}`"
                          :to="sublink.to"
                          :href="sublink.href"
                          target="_blank"
                        >
                          <v-list-item-avatar>
                            <v-icon color="primary" small> open_in_new </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title
                            class="sublink"
                            :class="{
                              'text-center': $vuetify.breakpoint.mdAndUp,
                              'text-left': $vuetify.breakpoint.smAndDown,
                            }"
                          >
                            <div v-html="sublink.name" />
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-else-if="sublink.href && sublink.download"
                          exact
                          two-line
                          :key="`sublink-${subIndex}`"
                          @click="showFile(sublink, sublink.embed)"
                        >
                          <v-list-item-title
                            class="sublink"
                            :class="{
                              'text-center': $vuetify.breakpoint.mdAndUp,
                              'text-left': $vuetify.breakpoint.smAndDown,
                            }"
                          >
                            <div v-html="sublink.name" />
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-else
                          exact
                          two-line
                          :key="`sublink-${subIndex}`"
                          :to="sublink.to"
                          :href="sublink.href"
                        >
                          <v-list-item-title
                            class="sublink"
                            :class="{
                              'text-center': $vuetify.breakpoint.mdAndUp,
                              'text-left': $vuetify.breakpoint.smAndDown,
                            }"
                          >
                            <div v-html="sublink.name" />
                          </v-list-item-title>
                        </v-list-item>
                        <div
                          v-if="subIndex < link.dropdown.links.length - 1"
                          class="nav-divider"
                          :key="`divider-${subIndex}`"
                        />
                      </template>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-list-item
                v-else
                exact
                :key="`link-${index}`"
                :to="link.to"
                :href="link.href"
                :download="link.download"
              >
                <v-icon v-if="link.download" color="primary" small
                  >save_alt</v-icon
                >
                <v-list-item-title
                  class="sublink text-center py-1"
                  v-html="link.name"
                />
              </v-list-item>
              <div
                v-if="index < links.length - 1"
                class="mx-0 nav-divider"
                :key="`divider-${index}`"
              />
            </template>
            <div class="mx-0 nav-divider" />
            <v-list-item
              href="https://vancouverglobalshipping.app.shipthis.co/session/signin"
            >
              <v-list-item-title class="sublink text-center py-1 primary--text font-weight-medium">
                Customer Login
              </v-list-item-title>
            </v-list-item>
            <div class="mx-0 nav-divider" />
            <v-list-item href="/#services">
              <v-list-item-title class="sublink text-center py-1 primary--text font-weight-medium">
                Quotes
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-divider class="mt-12" v-if="$vuetify.breakpoint.smAndDown" />
    <v-row justify="center" class="footer">
      <v-row
        md="3"
        v-for="(section, index) in footer"
        :key="`footer-${index}`"
        class="py-4"
        :class="{
          'px-7': $vuetify.breakpoint.xsOnly,
          'px-6': !$vuetify.breakpoint.xsOnly,
        }"
        style="flex: 0 0 300px"
      >
        <!-- <div
          style="flex: 0 0 95px;"
          class="body-2 font-weight-medium text-right"
          v-html="section.title"
        /> -->
        <v-col class="py-0 pl-6 pr-0">
          <div
            v-for="(row, rowIndex) in section.rows"
            :key="`section-${index}-row-${rowIndex}`"
            class="keep-all caption"
            :class="{
              'pb-1': $vuetify.breakpoint.mdAndUp,
              'pb-2': $vuetify.breakpoint.smAndDown,
            }"
            v-html="row"
          />
          <div
            v-for="(link, linkIndex) in section.links"
            class="pb-1"
            :class="{
              'pb-1': $vuetify.breakpoint.mdAndUp,
              'pb-5 underline': $vuetify.breakpoint.smAndDown,
            }"
            :key="`section-${index}-link-${linkIndex}`"
            style="line-height: 1.25em !important"
          >
            <router-link
              v-if="link.to"
              class="caption no-style hover pa-1"
              :to="link.to"
              v-html="link.title"
            />
            <a
              v-else-if="link.href && link.download && link.new"
              class="caption no-style hover pa-1"
              :href="link.href"
              v-html="link.title"
              target="_blank"
            />
            <a
              v-else-if="link.href && link.download"
              class="caption no-style hover pa-1"
              @click="showFile(link, link.embed)"
              v-html="link.title"
            />
            <a
              v-else-if="link.href"
              class="caption no-style hover pa-1"
              :href="link.href"
              v-html="link.title"
            />
          </div>
          <div v-if="section.title == 'CUSTOMER LOGIN'">
            <v-row justify="center">
              <div class="py-4">
                <div>©Vancouver Global Shipping</div>
                <a
                  target="_blank"
                  href="https://ca.linkedin.com/in/vancouver-global-shipping-2712ba183"
                >
                  <v-img
                    alt="linkedin"
                    class="mt-2"
                    :width="30"
                    contain
                    :src="require('./assets/linkedin.png')"
                  />
                </a>
              </div>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <!-- <div style="flex: 0 0 700px;">
        <v-row justify="center">
          <div class="py-4">
            <div>
              ©Vancouver Global Shipping
            </div>
            <a
              target="_blank"
              href="https://ca.linkedin.com/in/vancouver-global-shipping-2712ba183"
            >
              <v-img
                alt="linkedin"
                class="mt-2"
                :width="30"
                contain
                :src="require('./assets/linkedin.png')"
              />
            </a>
          </div>
        </v-row>
      </div> -->
    </v-row>
    <ComingSoonDialog ref="comingSoon" />
    <PDFDialog ref="pdfDialog" />
  </v-app>
</template>

<script>
import ComingSoonDialog from './components/ComingSoonDialog'
import PDFDialog from './components/PDFDialog'

export default {
  name: 'App',
  components: {
    ComingSoonDialog,
    PDFDialog,
  },
  data: () => ({
    footer: [
      {
        title: 'GENERAL',
        links: [
          { title: 'Home', to: { name: 'home' } },
          { title: 'About', to: { name: 'aboutus' } },
          { title: 'Contact', to: { name: 'contactus' } },
        ]
      },
      {
        title: 'SERVICES',
        links: [
          { title: 'Services', href: '/#services' },
          { title: 'Quote Request', href: '/#services' }, 
          { title: 'Customer Login', href: 'https://vancouverglobalshipping.app.shipthis.co/session/signin' },
          // { title: 'FAQ', download: 'Frequently Asked Questions', href: '/Frequently Asked Questions V1.0.pdf' },
        ]
      },
      {
        title: 'TERMS',
        links: [
          { title: 'Terms of Use', download: 'Terms of Use', embed: true, href: '/VGS_T&C.pdf' },
          { title: 'Privacy Policy', download: 'Privacy Policy', embed: true, href: '/PrivacyPolicy.pdf' },
          { title: 'VGS T&C', download: 'VGS Terms & Conditions', embed: true, href: '/VGSTermsAndConditions.html' },
        ]
      },
      {
        title: 'CUSTOMER LOGIN',
        links: [
          // { title: 'Customer Login', href: 'https://vancouverglobalshipping.app.shipthis.co/session/signin' },
        ]
      },
      {
        title: 'CONTACT',
        rows: [
          `<div><b>Address</b></div>           
          <div>104-11782 River Road, Richmond, BC</div>
          <div>V6X 1Z7</div>`,
          '',
          `<div><b>Phone</b></div>
          <div>604-275-9393</div>`,
          '',
          // `<div><b>Toll-Free</b></div>
          // <div>1-888-811-3250</div>`,
        ]
      }

      // {
      //   title: 'CONTACT US',
      //   rows: [
      //     'Office: 604-275-9393',
      //     'Fax: 604-275-0545',
      //     'Toll Free: 1-888-811-3250',
      //   ],
      // },
      // {
      //   title: 'SERVICES',
      //   links: [
      //     { title: 'Contact Us', to: { name: 'contactus' } },
      //     { title: 'Quotes', href: '/#services' },
      //     { title: 'Tracking', href: 'https://vancouverglobalshipping.app.shipthis.co/session/signin' },
      //     { title: 'FAQ', download: 'Frequently Asked Questions', href: '/Frequently Asked Questions V1.0.pdf' },
      //   ],
      // },
      // {
      //   title: 'INFORMATION',
      //   links: [
      //     { title: 'About Vancouver Global Shipping', to: { name: 'aboutus' } },
      //     { title: 'Work With Us', href: '/VGS T&C.pdf' },
      //     { title: 'Terms & Conditions', download: 'VGS - Terms & Conditions', href: '/VGS T&C.pdf' },
      //   ],
      // },
    ],
    links: [
      { name: 'About us', to: { name: 'aboutus' } },
      {
        name: 'Services',
        dropdown: {
          links: [
            { name: 'Ocean Freight', to: { name: 'services-ocean' }, },
            { name: 'Air Freight', to: { name: 'services-air-freight' }, },
            // { name: 'Import Services', to: { name: 'services-import' }, },
            { name: 'Automobile Shipping <br/> RORO & Container', to: { name: 'services-automobile' }, },
          ],
        },
      },
      {
        name: 'Resource',
        dropdown: {
          links: [
            { name: 'Incoterms® 2020', download: 'Incoterms 2020 Overview', href: '/INCOTERMS.pdf' },
            { name: 'Ocean Container Specifications', download: 'Container Specification Types', href: '/CONTAINER_SPECS_TYPES.pdf', },
            { name: 'Air Freight <br/> Container <br/> Specifications', download: 'Air Freight Specifications', href: '/AIR_FREIGHT_CONTAINER SPECS.pdf' },
            { name: 'International <br/> Ocean Ports', download: 'International Ocean Ports', href: '/INTERNATIONAL_OCEAN_PORTS.pdf', },
            // { name: 'Ocean Freight <br/> Container <br/> Specifications', download: 'Ocean Freight Specifications', href: '/OCEAN_CONTAINER_SPECIFICATIONS.pdf', },
            // { name: 'Form FDA 2877', download: 'FDA Form 2877', href: '/FDA_FORM_2877.pdf' },
            { name: 'Canada Airport <br/> Code List', download: 'Canada Airport Code List', href: '/CANADA_AIRPORT_LIST.pdf' },
            { name: 'Canada Customs <br/> Invoice', download: 'Canada Customs Invoice', new: true, href: '/CANADA_CUSTOMS_INVOICE.pdf' },
            { name: 'B13A Export Declaration', download: 'B13A Export Declaration', new: true, href: '/B13A_EXPORT_DECLARATION.pdf' },
            // { name: 'FAQ', download: 'Frequently Asked Questions', href: '/FAQ.pdf' },
          ],
        },
      },
      { name: 'Contact Us', to: { name: 'contactus' } },
    ],
    menu: false,
  }),
  watch: {
    $route(to) {
      document.title = `Vancouver Global Shipping - ${ to.meta.title }`;
      this.menu = false;
    },
  },
  methods: {
    comingSoon() {
      this.$refs.comingSoon.show()
    },
    showFile(link, embed) {
      this.$refs.pdfDialog.show({
        embed,
        title: link.download,
        href: link.href,
      })
    }
  },
};
</script>

<style scoped>
.nav-divider {
  border-bottom: 2px solid #ff0000;
}

.sublink {
  line-height: 22px !important;
}

.footer {
  background-color: #c4c4c4;
}
</style>

<style>
.divider-bottom {
  border-bottom: 1px solid #ff0000;
}

.max-width {
  width: 100%;
}

.max-height {
  height: 100%;
}

.text-shadow {
  text-shadow: 0px 0px 4px black;
}

.keep-all {
  word-break: keep-all;
}

a.no-style {
  color: unset !important;
  text-decoration: none;
}

a.no-style.hover:hover {
  text-decoration: underline;
}

.underline {
  text-decoration: underline;
}

.v-expansion-panel-content > .v-expansion-panel-content__wrap {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.expansion-header-nav > .v-expansion-panel-header__icon {
  position: absolute;
  right: 40px;
  padding-top: 10px;
}

.clickable {
  cursor: pointer;
}

.img-cover {
  background-color: rgba(0, 0, 0, 0.25);
  background-color: rgba(0, 0, 0, 0.44);
}

html {
  scroll-behavior: smooth;
}

.hidden {
  visibility: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

